import i18n from '@/i18n';

/** development */
export const isDevelopment = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

/** Langs */
export const defaultLang = 'fr';

export const Langs = ['fr'];
const pathLangRoute = ':lng(' + Langs.join('|') + ')';

export const getI18nPath = url => {
  return url.replace(pathLangRoute, i18n.language);
};

/** Router */
export const PATHS = {
  home: `/`,
  aboutUs: `/about-us`,
  projects: `/projects`,
  contact: `/contact`,
  jobs: `/jobs`,
  games: `/games`,
  privacy: `/privacy-policy`,
};

export const LINKS = {
  ysocorp: 'https://ysocorp.com',
  github: 'https://github.com/ysocorp',
  linkedin: 'https://www.linkedin.com/in/jeanclaudeyalap',
  api: 'https://ysocorp-api.herokuapp.com',
};
